import React from 'react'
import { checkTextTranslation, imageAddress } from '../../utils/useful'

class TableImageInput extends React.Component {
  state = {
  }

  componentDidMount() {
    let header = this.props.header
    let el = ''
    if(Array.isArray(header)){

      header.forEach(element => {
        if (element.type == 'FileInput') {
          { console.log('5555 1', element.information.page) }
          el = element.information.page
        }
      });
    }
    this.setState({ page: el })
  }

  changeInputValue(target) {
    let value = (target.validity.valid) ? target.value : null
    if (value !== null) {
      this.props.changeValue(this.props.header.key, value)
    }
  }


  render() {

    return (

      <div className={`text-center w-100 ${this.state.page ? '' : 'd-flex justify-content-center'}`} style={{ overflow: this.state.page ? '' : 'auto', padding: this.state.page ? '10px' : '' }}>
        {Array.isArray(this.props.data) && this.props.data.map((image, index) => {
          return (
            <a href={imageAddress(image)} target="_blank"><img key={index} src={'/images/file.svg'} style={{ width: 30, height: 30, borderRadius: this.state.page ? 0 : 20, objectFit: 'cover', marginLeft: 2 }} /></a>
          )
        })
        }

        {!Array.isArray(this.props.data) && this.props.data && (
          <a href={imageAddress(this.props.data)} target="_blank"><img src={'/images/file.svg'} style={{ width: 30, height: 30, borderRadius: this.state.page ? 0 : 20, objectFit: 'cover' }} /></a>
        )}

        {/* {this.state.page && (
          <div className='w-100'>
            <p className='pt-2 mx-2' style={{ fontSize: 11, color: "#222", verticalAlign: 'center' }}>{this.props.data}</p>
          </div>
        )} */}
      </div>

      // <div className="w-100 h-100">
      //     <p className="text-small" style={{ color: '#051015', textOverflow: 'ellipsis', overflow: 'hidden', width: '100%' }}>{this.props.data}</p>
      // </div>
    )
  }
}

export default TableImageInput;